import React, { ReactElement, Fragment } from 'react';
import classNames from 'classnames/bind';
import ReactTooltip from 'react-tooltip';

import style from './index.pcss';

export interface IPayload {
    // tslint:disable-next-line no-any
    [key: string]: any
}

export const cn = classNames.bind(style);

export const baseProps = {
    xmlns  : 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    width  : 24,
    height : 24
};

export default (children: (payload: IPayload) => ReactElement, optionsProps?: {}) => {
    return (props: IPayload = {}) => {
        return (
            <Fragment>
                <ReactTooltip />
                <svg {...(props.tooltip && { 'data-tip': props.tooltip })}  {...baseProps} {...optionsProps} {...props}>
                    {children(props)}
                </svg>
            </Fragment>
        );
    };
};
